import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSGuestyStore = GenericCollectionFactory("PMS-GUESTY-INTEGRATION", "id");